import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import { useEvaluationPeriodDetail } from './config/participants';
import PeriodOverviewTab from './tab-pages/PeriodOverviewTab';
import PeriodParticipantsTab from './tab-pages/PeriodParticipantsTab';
import PeriodScopeDiffTab from './tab-pages/PeriodScopeDiffTab';
import PeriodBandsTab from './tab-pages/PeriodBandsTab';

// Spec 2026-10-05 §15/4 — dönem detayı. Katılımcı ve kapsam farkı sekmeleri yalnız İK'ya
// (aktif enterpriseAdmin / superAdmin) görünür — backend de aynı kapıyı uygular (HrActorRules).
export default function EvaluationPeriodDetailPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  // İK rolü ayrımı — İK = sunucunun kararı (AuthContext.isHr), Şirket Yöneticisi DEĞİL.
  const { isHr } = useAuth();
  const { period } = useEvaluationPeriodDetail(id);
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = useMemo(() => {
    const list = [{ key: 'overview', label: t('performance.period.detail.tabOverview') }];
    if (isHr) {
      list.push({ key: 'participants', label: t('performance.period.participants.tab') });
      list.push({ key: 'scopeDiff', label: t('performance.period.scopeDiff.tab') });
      list.push({ key: 'bands', label: t('performance.period.bands.tab') });
    }
    return list;
  }, [t, isHr]);

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t('performance.period.title'), path: '/performance/periods' },
          { label: period?.name || '...' },
        ]}
      />
      <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      {activeTab === 'overview' && <PeriodOverviewTab period={period} />}
      {isHr && activeTab === 'participants' && <PeriodParticipantsTab period={period} />}
      {isHr && activeTab === 'scopeDiff' && <PeriodScopeDiffTab period={period} />}
      {isHr && activeTab === 'bands' && <PeriodBandsTab period={period} />}
    </>
  );
}
